import {Injectable, signal, WritableSignal} from '@angular/core';

@Injectable({ providedIn: 'root' })
export class MessageService {

  messages: WritableSignal<any[]> = signal([]);

  addCreated(summary: string): void {
    this.clearMessages();
    this.messages().push({ severity: 'success', content: summary, life: 3000 });
  }

  addEdited(summary: string): void {
    this.clearMessages();
    this.messages().push({ severity: 'success', content: summary, life: 3000 });
  }

  addError(summary: string): void {
    this.clearMessages();
    this.messages().push({ severity: 'error', content: summary, life: 10000 });
  }

  clearMessages(): void {
    this.messages.set([]);
  }

}
